import { useConfig } from "../../../contexts/ConfigContext";
import { COUNTRY_CODES } from "../../../constants/countries";
import * as Honduras from "./honduras/HondurasExtension";
import * as Paraguay from "./paraguay/ParaguayExtension";
import * as Ecuador from "./ecuador/EcuadorExtension";
import * as Salvador from "./salvador/SalvadorExtension";


// Mapa de extensiones disponibles
const COUNTRY_EXTENSIONS = {
    [COUNTRY_CODES.ECUADOR]: Ecuador,
    [COUNTRY_CODES.HONDURAS]: Honduras,
    [COUNTRY_CODES.PARAGUAY]: Paraguay,
    [COUNTRY_CODES.ELSALVADOR]: Salvador,
};

// Componente "nulo" que no renderiza nada (para países sin lógica en una sección)
const NullComponent = () => null;

// Hook de validación "nulo" que siempre pasa
const nullValidationHook = async () => true;
const nullSubmitHook = async () => ({
    ok: true
});

export const useCountryExtension = () => {
    const { country } = useConfig();
    const countryCode = country?.code;

    // Buscar si existe una extensión para ese código de país
    const extension = COUNTRY_EXTENSIONS[countryCode];

    // Devolver los componentes y hooks del país.
    // Si no existe la extensión o una parte específica, se devuelve una versión "nula".
    return {
        // Hook para lógica de modal de confirmacion de datos factura
        useConfirmationModal: extension?.useConfirmationModal || nullValidationHook,
        submitInvoiceAndPrepareFiscalTicket: extension?.submitInvoiceAndPrepareFiscalTicket || nullSubmitHook,

        // Componentes de UI para inyectar en "slots" específicos del formulario (InvoiceForm.js)
        InvoiceHeaderSlot: extension?.InvoiceHeaderSlot || NullComponent,
        ClientSectionSlot: extension?.ClientSection || NullComponent,
        BillingInfoSectionSlot: extension?.BillingInfoSection || NullComponent,
        CampaignSectionSlot: extension?.CampaignSection || NullComponent,
        ConfirmationSectionSlot: extension?.ConfirmationFormSection || NullComponent,
        TicketSectionSlot: extension?.TicketSection || NullComponent,

        // Componentes de UI para inyectar en "slots" específicos del listado de facturas (InvoiceList.js)
        DownloadTicketButtonSlot: extension?.DownloadTicketButton || NullComponent,
        DownloadInvoiceButtonSlot: extension?.DownloadInvoiceButton || NullComponent,
        PostInvoiceButtonSlot: extension?.PostInvoiceButton || NullComponent,
    };
};


